export enum tableName {
  HEALTH_INSURERS = 'health-insurers',
  DESTINATIONS = 'destinations',
}
